if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.interval = null;
    }

    connectedCallback() {
      const tz = this.dataset.timezone || 'Europe/Berlin';
      const dateStr = this.dataset.endDate;
      // Build a Date that represents the end date in the given timezone
      this.endDate = this.parseInTimezone(dateStr, tz);
      if (isNaN(this.endDate)) return;

      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');

      this.update();
      this.interval = setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    update() {
      const now = Date.now();
      const diff = this.endDate - now;

      if (diff <= 0) {
        clearInterval(this.interval);
        this.setValues(0, 0, 0, 0);
        this.dispatchEvent(new CustomEvent('countdown:ended'));
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      this.setValues(days, hours, minutes, seconds);
    }

    parseInTimezone(dateStr, tz) {
      // Create a date formatter for the target timezone
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: tz,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      });
      // Get the current offset between local time and target timezone
      // by comparing a known date in both
      const target = new Date(dateStr);
      const parts = formatter.formatToParts(target);
      const get = (type) => parseInt(parts.find(p => p.type === type).value);
      const tzDate = new Date(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'), get('second'));
      // The difference between target and tzDate gives us the offset
      const offset = target.getTime() - tzDate.getTime();
      return target.getTime() + offset;
    }

    setValues(days, hours, minutes, seconds) {
      if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
      if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
      if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
      if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
